import { render } from "./CooksyAbout.vue?vue&type=template&id=3912d4d0&scoped=true"
import script from "./CooksyAbout.vue?vue&type=script&lang=js"
export * from "./CooksyAbout.vue?vue&type=script&lang=js"

import "./CooksyAbout.vue?vue&type=style&index=0&id=3912d4d0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3912d4d0"]])

export default __exports__